const paymentOrder = (state = [], action) => {
    switch(action.type) {
        case 'paymentOrder':
            return action.payload;
        default:
            return state;
    }
}

export default paymentOrder;